import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { KLabel } from "./KLabel";
export var KCreditColor;
(function (KCreditColor) {
    KCreditColor["SECONDARY"] = "secondary";
    KCreditColor["DANGER"] = "danger";
    KCreditColor["WARNING"] = "warning";
    KCreditColor["PRIMARY"] = "primary";
    KCreditColor["SUCCESS"] = "success";
})(KCreditColor || (KCreditColor = {}));
export const KCredit = ({ remaining, total, infinite = false, labelText, color = KCreditColor.SECONDARY, percent = false }) => {
    let credit;
    if (infinite) {
        credit = (_jsxs(_Fragment, { children: [_jsx("span", { className: `bigNumber text-${color}`, children: _jsx("i", { className: "fa fa-md fa-infinity" }) }), _jsx("br", {}), _jsx(KLabel, { text: labelText ? labelText : "" })] }));
    }
    else {
        if (total) {
            credit = (_jsxs(_Fragment, { children: [_jsx("span", { className: `bigNumber text-${color}`, children: `${remaining}/` }), _jsx("span", { className: `bigNumber lightGray`, children: total }), _jsx("br", {}), _jsx(KLabel, { text: labelText ? labelText : "" })] }));
        }
        else {
            credit = (_jsxs(_Fragment, { children: [_jsx("span", { className: `bigNumber text-${color}`, children: `${remaining >= 0 ? remaining : "--"}${percent ? " %" : ""}` }), _jsx("br", {}), _jsx(KLabel, { text: labelText ? labelText : "" })] }));
        }
    }
    return credit;
};
